export default {
  views: {
    list: {
      key: "Ključ",
      data: "Vrednost",
      updated: "Posodobljeno",
      updated_at: "Posodobljeno",
      created_at: "Ustvarjeno",
      title: "Ime",
      category_id: "Kategorija",
      color: "Barva",
      icon: "Ikona",
      desc: "Opis",
      groupId: "Ključ skupine",
      groupName: "Ime skupine",

      brand: "Znamka",
      model: "Model",
      year_start: "Začetek izdelave",
      year_end: "Konec izdelave",

      save: "Shrani",
      remove: "Odstrani",
      remove_category_msg: "Šifrant {title} uspešno odstranjen.",
      remove_msg: "Vnos uspešno odstranjen.",
      remove_error: "Prišlo je do napake pri odstrnjevanju vnosa.",
      updated_msg: "Vnos uspešno posodobljen.",
      update_error: "Error has occurred while updating an item.",
      store_error: "Error has occurred while storing an item.",
      save_msg: "Vnos je bil uspešno dodan.",
      save_error: "Pri shranjevanju je prišlo do napake."
    },
    header: {
      title: "Šifranti",
      add: "Dodaj vnos"
    },
    category: {
      title: "Kategorije"
    },
    category_popup: {
      edit: "Uredi kategorijo",
      new: "Nova kategorija",
      title: "Naziv kategorije",
      schema: {
        label: "Shema",
        description: "Tukaj lahko opredelite shemo kategorije"
      },
      remove: "Odstrani",
      cancel: "Prekliči",
      save: "Shrani",
      add: "Dodaj",
      remove_prompt: {
        title: "Odstrani kategorijo?",
        msg: "Ste prepričani da želite odstraniti "
      },
      save_msg: "Kategorija je bila shranjena.",
      save_error: "Pri shranjevanju je prišlo do napake.",
      schema_error: "Shema ni pravilna."
    }
  }
}
